import { render, staticRenderFns } from "./all_terms_&_conditions.vue?vue&type=template&id=4b99fd34&scoped=true"
var script = {}
import style0 from "./all_terms_&_conditions.vue?vue&type=style&index=0&id=4b99fd34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b99fd34",
  null
  
)

export default component.exports